import { motion } from "framer-motion";
import { Globe } from "lucide-react";
import { HERO_IMAGE } from "../data/cards";

const GATE_ANIM = {
  initial: { opacity: 0, scale: 0.92 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 1.1, ease: "easeOut" },
};

const TITLE_ANIM = {
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay: 0.25 },
};

const SUBTITLE_ANIM = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.9, delay: 0.55 },
};

export const MysticHeader = () => {
  return (
    <header
      data-testid="app-header"
      className="relative w-full overflow-hidden"
    >
      {/* Brand bar */}
      <div className="flex flex-col items-center gap-2.5 pt-6">
        <a
          data-testid="brand-link"
          href="https://samantha-hellsehen-kartenlegen.de"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 group"
        >
          <img
            src="https://primary.jwwb.nl/public/q/n/q/temp-sjulsrprfbttovklyzuj/neues-logo-samantha-hellsehen-kartenlegen-high.png?enable-io=true&enable=upscale&height=70"
            alt="Samantha – Hellsehen & Kartenlegen"
            className="h-10 w-auto drop-shadow"
          />
          <span className="serif text-lg sm:text-xl font-semibold text-[#b8860b] tracking-wide group-hover:text-[#D4AF37] transition-colors">
            Samantha · Hellsehen &amp; Kartenlegen
          </span>
        </a>
        <a
          data-testid="brand-url"
          href="https://samantha-hellsehen-kartenlegen.de"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/70 backdrop-blur-sm border border-[#D4AF37]/40 text-[15px] font-medium text-[#6b4f12] glow-soft hover:border-[#D4AF37] hover:text-[#b8860b] transition-all duration-300"
        >
          <Globe size={15} className="text-[#D4AF37]" />
          samantha-hellsehen-kartenlegen.de
        </a>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 pt-6 pb-6 sm:pt-8 flex flex-col items-center text-center">
        {/* Golden gate */}
        <motion.div
          {...GATE_ANIM}
          className="relative w-full max-w-2xl rounded-[28px] overflow-hidden glow-strong"
        >
          <img
            src={HERO_IMAGE}
            alt="Offenes goldenes Tor"
            className="w-full h-[220px] sm:h-[300px] object-cover"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(255,255,255,0) 40%, rgba(255,248,231,0.35) 100%)",
            }}
          />
        </motion.div>

        {/* Title */}
        <div className="relative mt-8">
          <div className="title-aura" />
          <motion.h1
            {...TITLE_ANIM}
            className="script-title relative z-10 text-5xl sm:text-7xl px-2"
          >
            Berufs‑ &amp; Seelenweg‑Analyse
          </motion.h1>
        </div>

        <motion.p
          {...SUBTITLE_ANIM}
          className="serif relative z-10 mt-4 max-w-xl text-lg sm:text-xl text-[#6b4f12]"
          style={{ fontWeight: 500 }}
        >
          Finde Klarheit über deinen beruflichen Weg, deine Chancen und deinen
          inneren Antrieb.
        </motion.p>
      </div>
    </header>
  );
};
